<template>
    <b-modal v-model="modal_component.show"
             centered
             size="lg"
             :title="modal_component.action === 'c' ? 'Crear Componente': 'Editar Componente'"
             hide-header-close
             no-close-on-esc
             no-close-on-backdrop
    >
        <form @submit.prevent="validateForm()"
              data-vv-scope="component"
              autocomplete="off"
        >
            <b-row class="mb-2">
                <b-col md="3">
                    <b-form-group v-b-popover.html.hover.top.v-danger="errors.has(`component.cas_number`) ? errors.first(`component.cas_number`) : ''"
                                  v-bind:class="{'text-danger' : errors.has(`component.cas_number`)}"
                    >
                        <label for="cas_number">Número CAS</label>
                        <b-input-group size="sm">
                            <b-form-input id="cas_number"
                                          name="cas_number"
                                          size="sm"
                                          type="text"
                                          v-model="component.cas_number"
                                          data-vv-as=" "
                                          v-validate="'required|cas'"
                                          class="text-uppercase"
                                          @change="_findComponent(component.cas_number)"
                                          v-bind:class="{'border-danger text-danger' : errors.has(`component.cas_number`)}"
                            />
                            <b-input-group-append>
                                <el-tooltip effect="dark"
                                            content="MEZCLA"
                                            placement="bottom"
                                >
                                    <b-button :variant="errors.has(`component.cas_number`) ? 'outline-danger' : component.cas_number === 'MEZCLA' ? 'primary' : 'outline-primary'"
                                              @click="setCasNumberToComponent('MEZCLA')"
                                    >
                                        M
                                    </b-button>
                                </el-tooltip>
                            </b-input-group-append>
                            <b-input-group-append>
                                <el-tooltip effect="dark"
                                            content="NO REPORTADO"
                                            placement="bottom"
                                >
                                    <b-button :variant="errors.has(`component.cas_number`) ? 'outline-danger' : component.cas_number === 'NO REPORTADO' ? 'primary' : 'outline-primary'"
                                              @click="setCasNumberToComponent('NO REPORTADO')"
                                    >
                                        N/R
                                    </b-button>
                                </el-tooltip>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>

                <b-col md="9">
                    <b-form-group v-bind:class="{'text-danger' : errors.has(`component.name`)}">
                        <label for="name">Nombre</label>
                        <b-form-input id="name"
                                      name="name"
                                      size="sm"
                                      type="text"
                                      v-model="component.name"
                                      data-vv-as=" "
                                      v-validate="'required'"
                                      class="text-uppercase"
                                      v-bind:class="{'border-danger text-danger' : errors.has(`component.name`)}"
                        />
                        <span class="text-danger small"
                              v-text="errors.first('component.name')"
                        />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row class="mb-2">
                <b-col>
                    <label for="sga_categories">Clasificación SGA</label>
                    <el-select id="sga_categories"
                               name="sga_categories"
                               v-model="component.sga_categories"
                               size="small"
                               filterable
                               multiple
                               clearable
                               no-data-text="No hay datos que coincidan"
                               no-match-text="No hay datos que coincidan"
                               data-vv-as=" "
                    >
                        <el-option-group v-for="category in categories"
                                         :key="category.label"
                                         :label="category.label"
                        >
                            <el-option v-for="item in category.options"
                                       v-if="category.codigo !== 'NA'"
                                       :key="item.id"
                                       :label="item.codigo + ' ' + item.categoria"
                                       :value="item.id"
                            />
                        </el-option-group>
                    </el-select>
                    <span class="text-danger small"
                          v-text="errors.first('component.sga_categories')"
                    />

                    <b-alert show
                             variant="secondary"
                             class="mt-1"
                    >
                        <i class="fa fa-info-circle mr-1 text-warning"></i>
                        En caso de no seleccionar una clasificación del Sistema Globalmente Armonizado (SGA), el
                        producto será automáticamente marcado como "No Reportado" en el sistema.
                    </b-alert>
                </b-col>
            </b-row>
        </form>

        <template #modal-footer>
            <div class="w-100">
                <b-row>
                    <b-col cols="12"
                           class="text-center"
                    >
                        <b-button @click="validateForm"
                                  variant="primary"
                                  class="mr-1"
                                  size="sm"
                        >
                            <i class="fa fa-save"></i> Guardar
                        </b-button>
                        <b-button @click="closeModal"
                                  variant="secondary"
                                  class="ml-1"
                                  size="sm"
                        >
                            <i class="fa fa-close"></i> Cancelar
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </template>
    </b-modal>
</template>

<script>
import VeeValidate from 'vee-validate';
import {mapActions, mapMutations, mapState} from 'vuex';
import unit_converter from '../properties/unit_converter.vue';

// Extensión personalizada de VeeValidate para validar el número de CAS
VeeValidate.Validator.extend('cas', {
    getMessage: () => `
        <div>
          <p><strong>Error:</strong> El número de CAS ingresado es inválido.</p>
          <p>Por favor, asegurese de que cumpla con el siguiente formato:</p>
          <ul>
            <li><strong>Parte 1:</strong> Entre 2 y 7 dígitos numéricos.</li>
            <li><strong>Parte 2:</strong> Un guion seguido de 2 dígitos numéricos.</li>
            <li><strong>Parte 3:</strong> Un guion seguido de 1 dígito verificador.</li>
          </ul>
          <p>Ejemplo válido: <em>7732-18-5</em></p>
          <p>O también puede ingresar el texto "NO REPORTADO" o "MEZCLA"</p>
        </div>
    `,
    validate: (value) => {
        if (['MEZCLA', 'NO REPORTADO'].includes(value)) return true;

        const regex = /^[1-9]\d{1,6}-\d{2}-\d$/;

        if (!regex.test(value)) {
            return false;
        }

        const parts = value.split('-');
        const sinGuion = parts.join('');
        const checkDigit = parseInt(sinGuion.slice(-1), 10);
        const digits = sinGuion.slice(0, -1);
        let suma = 0;
        for (let i = 0; i < digits.length; i++) {
            suma += parseInt(digits[digits.length - 1 - i], 10) * (i + 1);
        }
        return (suma % 10) === checkDigit;
    }
});

export default {
    name: 'component',
    components: {unit_converter},
    computed: {
        ...mapState('calculator', [
            'modal_raw_material',
            'raw_material',
            'product',
            'categories',
            'component',
            'action_raw_material',
            'raw_materials',
            'modal_component',
            'action_component',
            'action_component'
        ])
    },
    created() {
        this.setPaginateFilter(false);
    },
    methods: {
        ...mapActions('calculator', [
            'getManufacturers',
            'createComponent',
            'updateComponent',
            'updateRawMaterial',
            'getRawMaterials',
            'getComponents',
            'findComponent'
        ]),
        ...mapMutations('calculator', [
            'setModalRawMaterialShow',
            'setCasNumberToComponent',
            'setPaginateFilter',
            'setModalComponentShow',
            'setModalComponentShow',
            'setCalComponentIdComponent',
            'setShowToModalWizard',
            'setCalComponentIdToComponentProduct',
            'setShowToModalRawMaterial',
            'addComponentToRawMaterial',
            'updateComponentToRawMaterial',
            'setNameToComponent'
        ]),
        async _findComponent(cas_number) {
            this.$validator.validate('component.cas_number').then(async () => {
                if (!!cas_number && !['MEZCLA', 'NO REPORTADO'].includes(cas_number) &&
                    !this.$validator.errors.has('component.cas_number')
                    && this.modal_component.action === 'c') {
                    await this.findComponent(cas_number)
                        .then(component => {
                            if (component) {
                                this.setNameToComponent(component.name);
                            }
                        });
                }
            });
        },
        validateForm() {
            this.$validator.validateAll('component')
                .then(async (result) => {
                    if (result) {
                        if (this.modal_component.action === 'c') {
                            await this.createComponent()
                                .then(async (component) => {
                                    this.addComponentToRawMaterial(component);
                                    this.closeModal();
                                });
                        } else {
                                this.updateComponentToRawMaterial(this.component);
                                this.closeModal();
                        }
                    }
                });
        },
        closeModal() {
            this.setModalComponentShow(false);
            this.setShowToModalRawMaterial(true);
        }
    }
};
</script>

<style>
.text-uppercase-input input {
    text-transform: uppercase;
}
</style>
